import { PlanCardBody, PlanListContainer, PlanListItem, PlanAdditional } from './styles';

import { Typography, Box } from '@material-ui/core';

export const PlanCardBodyV2 = ({ list, additionalSection }: any) => {
  const featureList = list;
  return (
    <>
      <PlanCardBody>
        <PlanListContainer>
          {featureList.map((list: any) => {
            return <PlanListItem style={{ fontWeight: list.isBold ? 700 : 500 }}>{list.description}</PlanListItem>;
          })}
        </PlanListContainer>
        {additionalSection ? (
          <PlanAdditional>
            <Typography style={{ fontSize: 12, fontWeight: 700 }}>
              {additionalSection.title}
              <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 5 }}> {additionalSection.span}</span>
            </Typography>

            <Box style={{ marginTop: 15 }}>
              <Typography style={{ fontSize: 12, fontWeight: 500 }}>{additionalSection.footer}</Typography>
              <Typography style={{ fontSize: 9, fontWeight: 400 }}>{additionalSection.subFooter}</Typography>
            </Box>
          </PlanAdditional>
        ) : null}
      </PlanCardBody>
    </>
  );
};
